import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, TextField, styled } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { makeStyles } from '@mui/styles';
import { visuallyHidden } from '@mui/utils';
import { enqueueSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { createNewGroupApi, getClusterResultApi, getGroupIdApi, upsertGoldenRecordApi } from "../api's/ClusterAPI";
import { WorkflowContext } from '../contexts/WorkflowProvider';
import LoadingIcon from '../reusable-component/LoadingIcon';

const useStyles = makeStyles((theme) => ({
  textField: {
    '& .MuiInputBase-root.Mui-disabled': {
      color: 'inherit', // Use 'inherit' to maintain the color
    },
    '& .MuiInputLabel-root.Mui-disabled': {
      color: 'inherit', // Use 'inherit' to maintain the color
    },
  },
}));

const ClusterResultPage = ({ issueGroupId, prevNodeId }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [groupId, setGroupId] = useState(issueGroupId);
  const [groupData, setGroupData] = useState([]);

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          <TableCell align="center" sx={{ backgroundColor: '#00043C', color: 'white' }}>
            Select
          </TableCell>
          <TableCell align="center" sx={{ backgroundColor: '#00043C', color: 'white' }}>
            Golden Record
          </TableCell>
          {tableHeaders.map((headCell) => (
            <TableCell
              align="left"
              sx={{
                backgroundColor: '#00043C',
                '&:hover': { color: 'white' },
                color: 'white',
              }}
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                sx={{
                  backgroundColor: '#00043C',
                  '&:hover': { color: 'white' },
                  color: 'white',
                }}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  const [tableData, setTableData] = useState([]);
  const [goldenRecordData, setGoldenRecordData] = useState({});
  const [tableHeaders, setTableHeaders] = useState([]);
  const { workflow } = useContext(WorkflowContext);

  const handleGoldenRecord = (key, value) => {
    setGoldenRecordData({ ...goldenRecordData, [key]: value });
  };

  const Container = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    width: '96%',
    position: 'absolute',
  });
  const ClusterDetails = styled(Box)({
    // border: '2px solid',
  });
  const TableDetails = styled(Box)({
    // border: '2px solid',
  });
  const GoldenRecordDetails = styled(Box)({
    // border: '2px solid',
  });

  // const getGroupData = async () => {
  //   setLoading(true);
  //   const response = await getGroupIdApi(`x360_mdm_output_${workflow.workflow_name.toLowerCase()}`);
  //   setGroupData(response.data);
  //   setGroupId(response.data[1].group_id);
  // };

  const getGroupData = async () => {
    setLoading(true);
    try {
      const payload = {
        // client_name: workflow.engagement.client.client_name,
        // engagement_name: workflow.engagement.engagement_name,
        // workflow_name: workflow.workflow_name,
        nodeId: prevNodeId,
      };
      const response = await getGroupIdApi(payload);
      if (response.status === 200) {
        setGroupData(response.data);
        setGroupId(issueGroupId.length > 0 ? issueGroupId : response.data[0].group_id);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }
    setLoading(false);
  };

  const fetchClusterData = async () => {
    setLoading(true);
    try {
      const data = {
        // client_name: workflow.engagement.client.client_name,
        // engagement_name: workflow.engagement.engagement_name,
        // workflow_name: workflow.workflow_name,
        nodeId: prevNodeId,
        groupId,
        update: {},
      };
      const response = await getClusterResultApi(data);
      if (response.status === 200) {
        setTableData(response.data.data);
        setDense(response.data.data.length > 2);
        setGoldenRecordData(response.data.goldenRecord);
        setTableHeaders(
          Object.keys(response.data.data[0]).map((key, index) => ({
            id: key,
            label: key,
          }))
        );
        setClickedCell(
          Object.keys(response.data.data[0]).map((key, index) => ({
            rowIndex: null,
            key,
          }))
        );
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setLoading(false);
  };

  const inputRef = useRef(null);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [clickedCell, setClickedCell] = useState([]);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [newGroupId, setNewGroupId] = useState(null);
  const [newGroupData, setNewGroupData] = useState([]);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const resetGoldenRecordData = () => {
    // Iterate over each property in the goldenRecordData object
    const resetData = Object.keys(goldenRecordData).reduce((acc, key) => {
      // Determine the default value based on the type of the current property value
      let defaultValue;
      if (typeof goldenRecordData[key] === 'string') {
        defaultValue = '';
      } else if (typeof goldenRecordData[key] === 'number') {
        defaultValue = null;
      } else if (typeof goldenRecordData[key] === 'boolean') {
        defaultValue = null;
      } else {
        defaultValue = null; // For other types, set to null
      }
      // Set the property value to the default value
      acc[key] = defaultValue;
      return acc;
    }, {});

    // Update the goldenRecordData state with the reset data
    setGoldenRecordData(resetData);
  };

  const handleOnRowClick = (event, row, rowIndex) => {
    event.persist();
    if (event.target.checked) {
      setSelectedRow(row);
      setGoldenRecordData(row);
      setClickedCell(Object.keys(row).map((key, index) => ({ rowIndex, key })));
    } else {
      setSelectedRow(null);
      resetGoldenRecordData();
      setClickedCell(clickedCell.map((item) => ({ ...item, rowIndex: null })));
    }
  };

  const handleOnCreateNewRecord = (event, row, rowIndex) => {
    event.persist();
    event.target.checked
      ? setNewGroupData([...newGroupData, row])
      : setNewGroupData(newGroupData.filter((item) => item !== row));
  };

  const createNewGroup = async () => {
    setLoading(true);
    try {
      if (groupId && newGroupId && newGroupId >= 0 && newGroupData.length !== 0) {
        const data = {
          oldGroupId: groupId,
          newGroupId,
          group_id_rank: newGroupData.map((item) => item.group_id_rank),
          nodeId: prevNodeId,
          // client_name: workflow.engagement.client.client_name,
          // engagement_name: workflow.engagement.engagement_name,
          // workflow_name: workflow.workflow_name,
        };
        const response = await createNewGroupApi(data);
        if (response.status === 200) {
          enqueueSnackbar('New group created successfully', {
            variant: 'success',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
          setNewGroupId(null);
          setNewGroupData([]);
          setGroupId([]);
          getGroupData();
        }
      } else if (!groupId) {
        enqueueSnackbar('Enter a valid group id', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (!newGroupId || newGroupId < 0) {
        enqueueSnackbar('Enter a valid new group id', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (newGroupData.length === 0) {
        enqueueSnackbar('Select a group to proceed', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }
    setLoading(false);
  };

  const handleOnCellClick = (event, key, value, rowIndex) => {
    setClickedCell(clickedCell.map((item) => (item.key === key ? { ...item, rowIndex } : item)));
    handleGoldenRecord(key, value);
  };

  const isRowPresent = (row, data) => data.some((item) => JSON.stringify(item) === JSON.stringify(row));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleGroupId = (event) => {
    setGroupId(event.target.value);
  };

  const handleNewGroupId = (event) => {
    setNewGroupId(parseInt(event.target.value, 10));
  };

  const handleSubmitGoldenRecord = async () => {
    setLoading(true);
    try {
      if (tableData.length === 1) {
        enqueueSnackbar('Already a golden record', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (
        tableData.length > 1 &&
        goldenRecordData.group_id !== undefined &&
        goldenRecordData.group_id !== null
      ) {
        // const update_data = goldenRecordData;
        // Object.keys(update_data).forEach((key) => {
        //   if (update_data[key] === null) {
        //     update_data[key] = '';
        //   }
        // });
        const data = {
          nodeId: prevNodeId,
          groupId,
          update: goldenRecordData,
        };
        const response = await upsertGoldenRecordApi(data);
        if (response.status === 200) {
          enqueueSnackbar('Golden record created successfully', {
            variant: 'success',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
      } else {
        enqueueSnackbar('Select a golden record to proceed', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (error.response?.status === 500) {
        enqueueSnackbar('500 Internal Server Error!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else if (error.response?.status === 404) {
        enqueueSnackbar('404 Client not found!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Something went wrong!', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getGroupData();
  }, []);

  useEffect(() => {
    groupId.length !== 0 && fetchClusterData();
  }, [groupId]);

  // const visibleRows = React.useMemo(
  //   () =>
  //     stableSort(tableData, getComparator(order, orderBy)).slice(
  //       page * rowsPerPage,
  //       page * rowsPerPage + rowsPerPage
  //     ),
  //   [order, orderBy, page, rowsPerPage]
  // );

  useEffect(() => {
    order &&
      orderBy &&
      setTableData(
        stableSort(tableData, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      );
  }, [order, orderBy, page, rowsPerPage]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [newGroupId]);

  const handleGroupIdChange = (event, value) => {
    setGroupId(value || '');
  };

  return (
    <Container>
      {!loading && (
        <Box>
          {/* <ClusterDetails>
          <PageHeaderTable data={headerData} />
            </ClusterDetails> */}
          {tableData.length !== 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '16px' }}>
              <Autocomplete
                disablePortal
                id="group-id-autocomplete"
                getOptionLabel={(option) => option.toString()}
                options={groupData.map((option) => option.group_id)}
                value={groupId}
                onChange={(event, value) => handleGroupIdChange(event, value)}
                style={{ width: '20%' }}
                loading={loading}
                renderInput={(params) => <TextField {...params} label="Group Id" variant="outlined" size="small" />}
              />

              <TextField
                style={{ width: '20%' }}
                label="New Group Id"
                id="outlined-size-small"
                margin="none"
                type="number"
                name="newGroupId"
                size="small"
                onChange={handleNewGroupId}
                value={newGroupId}
                inputRef={inputRef}
              />
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#00043C',
                  '&:hover': { backgroundColor: '#00043C' },
                }}
                onClick={createNewGroup}
              >
                {/* <MdAdd /> */}
                Create Group
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#00043C',
                  '&:hover': { backgroundColor: '#00043C' },
                }}
                onClick={handleSubmitGoldenRecord}
              >
                {/* <MdAdd /> */}
                Create Golden Record
              </Button>

              {/* <button
                onClick={handleOpenModal}
                style={{
                  marginTop: "10px",
                  marginLeft: "auto",
                  border: "none",
                  background: "none",
                }}
              >
                <BotButton />
              </button> */}
            </Box>
          )}

          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{ backgroundColor: '#ddd' }}
            >
              Golden Record Details
            </AccordionSummary>
            <AccordionDetails>
              <GoldenRecordDetails>
                {tableHeaders.map((header) => (
                  <TextField
                    key={header.id}
                    id={header.id}
                    label={header.label}
                    size="small"
                    value={goldenRecordData[header.label]}
                    disabled
                    className={classes.textField}
                    sx={{
                      backgroundColor: '#ffffff',
                      width: '12%',
                      marginTop: '10px',
                      marginRight: '10px',
                    }}
                  >
                    {goldenRecordData[header.label]}
                  </TextField>
                ))}
              </GoldenRecordDetails>
            </AccordionDetails>
          </Accordion>
          <TableDetails>
            {tableData.length !== 0 && (
              <Box sx={{ width: '100%', marginTop: '10px' }}>
                <Paper sx={{ width: '100%', mb: 2 }}>
                  <TableContainer>
                    <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="small">
                      <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={tableData.length}
                        tableHeaders={tableHeaders}
                      />
                      <TableBody>
                        {tableData.map((row, rowIndex) => (
                          <TableRow
                            key={rowIndex}
                            // style={{
                            //   backgroundColor: selectedRow === row ? 'lightgreen' : 'inherit',
                            // }}
                          >
                            <TableCell align="center">
                              <Checkbox
                                size="small"
                                onChange={(event) => handleOnCreateNewRecord(event, row, rowIndex)}
                                checked={isRowPresent(row, newGroupData)}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Checkbox
                                size="small"
                                onChange={(event) => handleOnRowClick(event, row, rowIndex)}
                                checked={selectedRow === row}
                              />
                            </TableCell>
                            {tableHeaders.map((header, index) => (
                              <TableCell
                                key={header.id}
                                align="left"
                                style={{
                                  backgroundColor:
                                    clickedCell[index]?.rowIndex === rowIndex &&
                                    clickedCell[index]?.key === header.label
                                      ? 'lightgreen'
                                      : isRowPresent(row, newGroupData)
                                      ? '#ffd453'
                                      : 'inherit',
                                }}
                                value={row[header.label]}
                                onClick={(event) => handleOnCellClick(event, header.label, row[header.label], rowIndex)}
                              >
                                {row[header.label] === true ? (
                                  'true'
                                ) : row[header.label] === false ? (
                                  'false'
                                ) : header.label === 'image_data' && row[header.label] ? (
                                  <img
                                    src={`data:image/png;base64,${row[header.label]}`}
                                    height={250}
                                    width={250}
                                    alt="image_data"
                                  />
                                ) : (
                                  row[header.label]
                                )}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={tableData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
                {/* <FormControlLabel
            control={<Switch checked={dense} onChange={handleChangeDense} />}
            label="Dense padding"
          /> */}
              </Box>
            )}
          </TableDetails>
          {/* <Box>Prev Next</Box> */}
        </Box>
      )}

      {loading && <LoadingIcon />}
    </Container>
  );
};

export default ClusterResultPage;
